import { instance } from './api';

export const postPDF = (domain, model, template, params) =>
  instance.post(`/api/v1/pdf/${domain}/${model}/${template}`, params);
